import React from 'react';
import styled from 'styled-components';
import {Colors, FontStyles} from "../constants";

export const Button = styled.button`
    width: ${props => props.width || 263}px;
    height: ${props => props.height || 50}px;
    border-radius: 10px;
    background-color: ${Colors.button};
    cursor: pointer;
    outline: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    ${FontStyles.button};
    color: white;
    
    :hover {
    background-color: ${Colors.buttonHover};      
    }
`;

export const ButtonOutline = styled.button`
    height: 50px;
    width: 263px;
    border-radius: 10px;
    border: solid 1px ${Colors.button};
    background-color: transparent;
    text-transform: uppercase;
    cursor: pointer;
    outline: none;
    ${FontStyles.button};
    
    :hover {
      background-color: rgba(255,255,255,0.3);      
      border: solid 1px ${Colors.buttonHover};
    }
`;

export const LightButton = styled(Button)`
  background-color: #FFFFFF;
  color: ${Colors.button};
  :hover {
    background-color: ${Colors.buttonLightHover};      
   }
`;